import {
    BLOG_CATEGORY_SEARCH_PARAMS,
    BLOG_CATEGORY_SORT_VALUES,
    DEFAULT_BLOG_CATEGORY_PAGE_SIZE,
} from '../../constants';

export const getBlogCategorySearchParams = (
    searchParams: {
        [key: string]: string | undefined;
    } = {},
): {
    currentPage: number;
    pageSize: number;
    sort?: string;
} => {
    const { puslapis, puslapyje, rikiavimas } = searchParams;
    const currentPage = puslapis ? +puslapis : 1;
    const pageSize = puslapyje ? +puslapyje : DEFAULT_BLOG_CATEGORY_PAGE_SIZE;

    return { currentPage, pageSize, sort: rikiavimas };
};

export const getNextArticlesUrl = ({
    path,
    currentPage,
    pageSize,
    sort,
}: {
    path: string;
    currentPage: number;
    pageSize: number;
    sort?: string;
}) => {
    const currentSearchParams = new URLSearchParams();

    if (currentPage !== 1) {
        currentSearchParams.set(BLOG_CATEGORY_SEARCH_PARAMS.PAGE, currentPage.toString());
    }

    if (pageSize !== DEFAULT_BLOG_CATEGORY_PAGE_SIZE) {
        currentSearchParams.set(BLOG_CATEGORY_SEARCH_PARAMS.PAGE_SIZE, pageSize.toString());
    }

    if (sort && sort !== BLOG_CATEGORY_SORT_VALUES.NEWEST) {
        currentSearchParams.set(BLOG_CATEGORY_SEARCH_PARAMS.SORT, sort);
    }

    const searchParamsString = currentSearchParams.toString();

    return searchParamsString ? `${path}?${searchParamsString}` : path;
};
